import React, {useEffect, useState} from 'react';
import HotItem from './hotItem';
import hotTop from '@/assets/imgs/hotlist/hot-top.png';
import hotBg from '@/assets/imgs/hotlist/hot-bg.png';
import {getHotList} from '../result/result-service';
import {HOT_LIST_TYPE} from './const';
import {HotListProps, WinnerData} from './index.d';
import {useCircularScroll} from './use-circular-scroll';
import {useScreenSize} from '../hooks/size.hooks';
import styles from './index.module.scss';

export default function HotListNext(props: HotListProps) {
  const [allData, setAllData] = useState<WinnerData[]>([]);
  const {calcActualSize} = useScreenSize();
  const [allDataHeight, setAllDataHeight] = useState(calcActualSize(176)); // 这里转化成rem
  // 初始化数据
  useEffect(() => {
    const fetchWinners = async () => {
      try {
        const data = await getHotList(HOT_LIST_TYPE[props.type]);
        console.log('data', data);
        // const {list} = require('./list.json');
        setAllData(data);

        // setWinners(list.slice(0, 3));
      } catch (error) {
        console.error('Failed to fetch winners:', error);
      }
    };

    fetchWinners();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (allData?.length <= 3) {
      console.log('list', allData);
      // 如果一条的时候
      if (allData.length === 1) {
        const newHeight = calcActualSize(64);
        setAllDataHeight(newHeight);
      } else {
        const newHeight = calcActualSize(24 + allData.length * 48);
        setAllDataHeight(newHeight);
      }
    } else {
      const newHeight = calcActualSize(176);
      setAllDataHeight(newHeight);
    }
  }, [allData]); // eslint-disable-line react-hooks/exhaustive-deps
  //   处理动画滚动
  //allData 闭环链表，然后实现向上滚动动画效果，不借助第三方组件，自己实现一个闭环链表，向上无限滚动，类似轮播图效果
  //   transform translate3d(0px, -48px, 0px)
  //   让数据动起来

  const {visibleItems, duration} = useCircularScroll({
    data: allData,
    visibleCount: 3,
    duration: 1000,
    delay: 3000,
    itemHeight: 50,
  });
  if (visibleItems?.length === 0) {
    return null;
  }

  return (
    <div
      className={`pl-3 pr-3 ${
        props.wrapperClassName ? props.wrapperClassName(allData) : ''
      }`}
      id="hot-list">
      <div className="relative rounded-lg overflow-hidden">
        <div
          className={`flex items-center p-2 gap-2 ${styles.hot_list_container}`}>
          <img src={hotTop} alt="Trophy" className="w-6 h-6" />
          <h3 className="text-white font-bold text-sm">Latest Wins</h3>
        </div>
        <div
          className={`flex flex-col gap-2 p-3 overflow-hidden max-h-[11rem] ${
            allData.length > 0 ? '' : 'hidden'
          }`}
          style={{
            backgroundImage: `url(${hotBg})`,
            backgroundSize: 'cover',
            position: 'relative',
            height: allDataHeight,
          }}>
          {visibleItems?.map((item, index) => (
            <div key={`${item.data?.userName}-${index}`} className="relative">
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  transform: `translateY(${item.translateY}px)`,
                  transition: `transform ${duration}ms linear`,
                  willChange: 'transform', // 提高性能
                  backfaceVisibility: 'hidden', // 防止闪烁
                  WebkitFontSmoothing: 'antialiased',
                  //   如果只有一条数据，或者三条数据的时候，最后一个没有borderBottom
                  //   paddingBottom: '4px',
                  //   borderBottom: '1px solid #786425',
                }}>
                <HotItem winner={item.data} />
                {index < visibleItems.length - 1 && (
                  <div className="h-[1px] w-full bg-[#786425] mt-2" />
                )}
              </div>
            </div>
            // <HotItem winner={item} key={item?.userName} style={style} />
          ))}
        </div>
      </div>
    </div>
  );
}
